import React from 'react'

import StoresTable from 'components/Cards/StoresTable'

export default function StoresList() {
    return (
        <>
            <div className="flex flex-wrap mt-4">
                <div className="w-full mb-12 px-4">
                    <StoresTable />
                </div>
            </div>
        </>
    )
}
